import { Controller } from "stimulus";
import Flatpickr from "flatpickr";

let flatpickrStart;
export default class extends Controller {
  static targets = ["dateRangeStart", "dateRangeEnd", "showMore", "tableBody"];

  connect() {
    var link = document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("type", "text/css");
    link.setAttribute("href", "https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css");
    document.getElementsByTagName("head")[0].appendChild(link);

    flatpickrStart = Flatpickr(this.dateRangeStartTarget, {
      onChange: (dates, dateStr) => {
        const params = new URLSearchParams(window.location.search);
        params.set("start_date", dateStr);
        params.set("end_date", this.dateRangeEndTarget.value);
        window.location.search = params.toString();
      }
    });

    Flatpickr(this.dateRangeEndTarget, {
      onChange: (dates, dateStr) => {
        const params = new URLSearchParams(window.location.search);
        params.set("start_date", this.dateRangeStartTarget.value);
        params.set("end_date", dateStr);
        window.location.search = params.toString();
      }
    });

    this.currentPage = 1;
  }

  changeStartDate(target){
    let numberOfDays = target.target.dataset.days;
    if(numberOfDays === "ytd"){
      let startOfYearDate = new Date(new Date().getFullYear(), 0, 1);
      numberOfDays = (Date.now() - startOfYearDate) / (1000 * 3600 * 24)
    }
    let startDate = new Date(Date.now() - numberOfDays * 24 * 60 * 60 * 1000)
    flatpickrStart.setDate(startDate, true)
  }

  showMore() {
    if (this._hasLoadedMaximum()) return;

    this.showMoreTarget.disabled = true;
    this.currentPage++;

    let url = new URL(window.location);
    url.searchParams.set("page", this.currentPage);
    url.searchParams.set("load_more", "true");

    fetch(url.toString(), { credentials: "same-origin" })
      .then(response => response.text())
      .then(content => {
        if (content) {
          this.tableBodyTarget.insertAdjacentHTML("beforeend", content);
          this.showMoreTarget.disabled = false;
          this._hideShowMoreButtonIfMaxArticlesLoaded();
        }
      });
  }

  _hasLoadedMaximum() {
    return this.currentPage >= this.showMoreTarget.dataset.maxPages;
  }

  _hideShowMoreButtonIfMaxArticlesLoaded() {
    if (this._hasLoadedMaximum()) {
      this.showMoreTarget.style.display = "none";
    }
  }
}
